import React from 'react';
import { block } from 'bem-cn';

import './photo-pion-image.scss';

const b = block('photo-pion-image');

type PhotoPionImagePropsType = {
  url: string;
  caption?: string;
};
const PhotoPionImage = ({ url, caption }: PhotoPionImagePropsType) => (
  <figure className={b()}>
    <div className={b('image-wrapper')}>
      <img
        data-testid='photo-pion-image'
        className={b('img')}
        src={url}
        alt={caption}
      />
    </div>
    {caption && (
      <figcaption data-testid='photo-pion-caption' className={b('caption')}>
        {caption}
      </figcaption>
    )}
  </figure>
);

export default PhotoPionImage;
